import { from } from 'rxjs';
import { AuthHttp } from '@common/services';
import { getRequestParams } from '@helpers';
import { API_URL } from '@common/config';

const adminURL = API_URL + '/admin/api/v1/';

/**
 * GET /api/v1/users/:userId
 *
 * @param userId
 */
export function getUserDetailsAPI(userId) {
  const url = `/users/${userId}`;
  return from(AuthHttp.get(url));
}

/**
 * GET /users
 *
 */
export function getUsersAPI(params) {
  const requestParams = getRequestParams(params);
  const url = `users?${requestParams}`;
  return from(AuthHttp.get(url));
}

/**
 * PATCH /users/{id}/update
 *
 */
export function updateUserDetailsAPI(id, body) {
  const url = adminURL + `users/${id}/update`;
  return from(AuthHttp.patch(url,body));
}

/**
 * PATCH /users/{id}/update
 *
 */
export function inviteUsersAPI(body) {
  const url = adminURL + 'users/invitation';
  return from(AuthHttp.post(url,body));
}

/**
 * Get /users
 *
 */
export function getUserManagementAPI(params) {
  const requestParams = getRequestParams(params);
  const url = adminURL + `users?${requestParams}`;
  return from(AuthHttp.get(url));
}